import '../../App.css';
import './index.css';
import MenuSuperior from "../Components/MenuSuperior";
import HeroStatic from "../Components/HeroStatic";
import QuemSomos from './quemSomos';
import Meta from './meta';
import SobreNos from '../Components/SobreNos';
import Footer from "../Components/Footer";

const index = () => {
    return (
        <div>
            <MenuSuperior />
            <HeroStatic title={'Sobre Nós'} />
            <div>
                <SobreNos buttonVisible={false} />
                <QuemSomos />
                <Meta />
            </div>
            <Footer />
        </div >
    )
}

export default index;